export default __webpack_public_path__ + "static/media/trophyIcon.67845cec.png";